// extracted by mini-css-extract-plugin
export default {"status_processing":"EstampStyle_status_processing__kbN4s","max_w_50":"EstampStyle_max_w_50__WAEDq"};